module.exports = __webpack_public_path__ + "static/media/frente2.57e8428d.JPG";